import BaseService from './BaseService'

interface ITemplateSetting {
  companyId: string
  templateLibraryAccessEnabled: boolean
}

class TemplateService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  update = (body: ITemplateSetting) => this.requests.post(`/template-settings/update`, body)
  getByCompanyId = (companyId:string) => this.requests.get(`/template-settings/${companyId}`)
}

const instance = new TemplateService(BaseService.servicesConfig.Templates)

export default instance
